export default "__VITE_ASSET__ed6e721e__"